import React from 'react';
export const OfferSection = () => {
  return <section className="w-full py-16 bg-gradient-to-b from-yellow-50 to-yellow-100" data-id="element-216">
      <div className="max-w-4xl mx-auto px-4" data-id="element-217">
        <div className="text-center mb-12" data-id="element-218">
          <p className="text-xl text-gray-600 italic" data-id="element-219">
            Czas na Twoją transformację
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-xl p-8 md:p-12" data-id="element-220">
          <div className="flex flex-col md:flex-row items-center" data-id="element-221">
            <div className="w-full md:w-1/2 mb-8 md:mb-0" data-id="element-222">
              <div className="relative" data-id="element-223">
                <div className="relative z-10" data-id="element-224">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xhjJXMWjehcjpD3oFerzNw/ebook-mockup.jpg.png" alt="Ebook - Od Frustracji do Siły" className="w-full max-w-xs mx-auto rounded-lg shadow-lg" data-id="element-225" />
                </div>
                <div className="absolute top-4 right-4 md:top-8 md:right-0 z-20 bg-red-600 text-white text-sm font-bold py-2 px-4 rounded-full transform rotate-12" data-id="element-226">
                  BESTSELLER
                </div>
              </div>
            </div>
            <div className="w-full md:w-1/2" data-id="element-227">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-228">
                "Jak odzyskać miłość męża - nawet jeśli wydaje się, że już za
                późno"
              </h2>
              <div className="mb-6" data-id="element-229">
                <div className="flex items-center mb-2" data-id="element-230">
                  <div className="text-yellow-400 flex" data-id="element-231">★★★★★</div>
                  <span className="ml-2 text-gray-600 text-sm" data-id="element-232">
                    (247 opinii)
                  </span>
                </div>
                <p className="text-gray-700" data-id="element-233">
                  Praktyczny poradnik, który pomoże Ci przerwać błędne koło
                  emocjonalnego odrzucenia i odbudować więź z mężem - nawet
                  jeśli teraz wydaje się to niemożliwe.
                </p>
              </div>
              <div className="mb-6" data-id="element-234">
                <div className="flex items-center" data-id="element-235">
                  <div className="text-3xl md:text-4xl font-bold text-gray-400 line-through" data-id="element-236">
                    39,99 zł
                  </div>
                  <div className="ml-4 text-4xl md:text-5xl font-bold text-yellow-600" data-id="element-237">
                    29,99 zł
                  </div>
                </div>
              </div>
              <div className="space-y-3 mb-8" data-id="element-238">
                <div className="flex items-center" data-id="element-239">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-240">
                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-241">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-242"></path>
                    </svg>
                  </div>
                  <p className="text-gray-700" data-id="element-243">
                    Mniej niż kolacja w restauracji (60 zł)
                  </p>
                </div>
                <div className="flex items-center" data-id="element-244">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-245">
                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-246">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-247"></path>
                    </svg>
                  </div>
                  <p className="text-gray-700" data-id="element-248">
                    Mniej niż wizyta u fryzjera (120 zł)
                  </p>
                </div>
                <div className="flex items-center" data-id="element-249">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-250">
                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-251">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-252"></path>
                    </svg>
                  </div>
                  <p className="text-gray-700" data-id="element-253">
                    Mniej niż jedna sesja terapii par (200 zł)
                  </p>
                </div>
                <div className="flex items-center" data-id="element-254">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-255">
                    <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-256">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-257"></path>
                    </svg>
                  </div>
                  <p className="text-gray-700 font-bold" data-id="element-258">
                    A może uratować 20 lat małżeństwa
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 bg-white p-6 rounded-lg shadow-lg" data-id="element-259">
          <div className="flex items-center" data-id="element-260">
            <div data-id="element-261">
              <h3 className="text-xl font-bold mb-2" data-id="element-262">W PAKIECIE OTRZYMASZ:</h3>
              <ul className="space-y-2" data-id="element-263">
                <li className="flex items-center" data-id="element-264">
                  <span className="text-green-500 mr-2" data-id="element-265">✓</span>
                  <span data-id="element-266">Ebook "Od Frustracji do Siły" (wartość 39,99 zł)</span>
                </li>
                <li className="flex items-center" data-id="element-267">
                  <span className="text-green-500 mr-2" data-id="element-268">✓</span>
                  <span data-id="element-269">5 ćwiczeń praktycznych (wartość 19,99 zł)</span>
                </li>
                <li className="flex items-center" data-id="element-270">
                  <span className="text-green-500 mr-2" data-id="element-271">✓</span>
                  <span data-id="element-272">Plan działania na 21 dni (wartość 29,99 zł)</span>
                </li>
            
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
};